import React, { Fragment, memo, useEffect, useState, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import Botones from '../../../components/UI/botonera/headerBotones.js';
import FrmBotones from '../../../components/UI/botonera/formBotones.jsx'
import DatePicker from '../../../components/UI/dataPicker/dataPicker.jsx';
import MonthYearPicker from '../../../components/UI/dataPicker/monthYearPicker.jsx'
import ComboBox from '../../../components/UI/comboBox/combobox.jsx';
import TablaFiltro from '../../../components/UI/tablaFiltro/tablaFiltroSort.jsx';
import ListaDatos from '../../../components/UI/listaDatosBusqueda/index.jsx'
function listaAsientosInt(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className="row">
                            <MonthYearPicker id="fecMesAno" col="6" pvalue={props.Datos.fecMesAno.value} attributes={props.Datos.fecMesAno.attributes} label={props.Datos.fecMesAno.attributes.label} handleChange={props.onhandleChangeDate} />
                            <ComboBox id="cmbEstado" col="6" attributes={props.Datos.Estado.attributes} value={props.selectedEstado} label={props.Datos.Estado.attributes.label} datos={props.listaEstado} onChange={props.onhandleSelectedEstado} />
                        </div>
                        <div className='row'>
                            <ComboBox id="cmbTipoAs" col="6" attributes={props.Datos.TipoAS.attributes} value={props.selectedTipoA} label={props.Datos.TipoAS.attributes.label} datos={props.listaTipoAS} onChange={props.onhandleSelectedTipoA} />
                            <FrmBotones col="6" attributes={props.Datos.BotonesAS.attributes} botones={props.botonFiltro} />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <div id="master-tabla" className="table-responsive  col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <TablaFiltro
                                        columnas={props.columnasAS}
                                        datos={props.listaGralAs}
                                        keyField={'llave'}
                                        modo={props.cellEditAS}
                                        rowEvents={props.rowEventsAS}
                                        selectRow={props.selectRowAS}
                                        //rowStyle={props.rowStyleAP}
                                        nombreCSV={"Asientos"}
                                        botonesLista={props.botonesLista}
                                        botones={true}
                                        busqueda={true}
                                        muestraTodo={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};
export default (withRouter(memo(listaAsientosInt)));